import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { useAuth } from 'hooks/useAuth';

export const AdminRoute = ({ children, role }) => {
  const { user } = useAuth();

  return user?.adminStatus === role ? children : <Navigate to={-1} />;
};

AdminRoute.propTypes = {
  children: PropTypes.node,
  role: PropTypes.string,
};
